enum ServerConnectionState {
  Connected = 'Connected',
  Connecting = 'Connecting',
  Disconnected = 'Disconnected',
  Initializing = 'Initializing',
  TroubleConnecting = 'TroubleConnecting',
}

export default ServerConnectionState;
